(function () {
    'use strict';

    angular.module('Services').service('LineItemsTable', LineItemsTable);
    LineItemsTable.$inject = [
        'TableLiteFactory',
        'patternFactory',
    ];

    function LineItemsTable(
        TableLiteFactory,
        patternFactory
    ) {
        return function (creditNote, updateCallback) {
            const headers = [
                {
                    label: 'CONSIGNMENT ID',
                    viewName: 'consignmentIdEdit',
                    fieldName: 'consignmentId',
                    inputType: 'text',
                    width: '150px',
                    hasError: function (row, name) {
                    }
                }, {
                    label: 'DESCRIPTION',
                    viewName: 'descriptionEdit',
                    fieldName: 'description',
                    inputType: 'text',
                    hasError: function (row, name) {
                    }
                }, {
                    label: 'TYPE',
                    viewName: 'typeEdit',
                    fieldName: 'type',
                    width: '150px'
                },
                {
                    label: 'AMOUNT',
                    viewName: 'amountEdit',
                    fieldName: 'amount',
                    width: '150px',
                    hasError: function (row, name) {
                        const value = Number(row.amountEdit.valTemp);
                        return isNaN(value);
                    }
                }
            ];

            const tableData = {
                form: creditNote.form,
                config: {
                    tableMinHeight: '200px',
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noFooter: true
                },
                headers: [...headers, {
                    label: 'Action',
                    viewName: 'action'
                }],
                data: [],
                patternDecimal: patternFactory.decimal
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function (callback) {
                    callback({content: creditNote.data.lineItems})
                },
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    id: creditNote.data.invoiceId,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                if (!data) {
                    return tableData;
                }
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    row.consignmentIdEdit = {
                        url: '/templates/directives/intellectual-table/body-cells/textInput.html',
                        value: row.consignmentId,
                        model: row.consignmentId,
                        disabled: true
                    };

                    row.descriptionEdit = {
                        url: '/templates/directives/intellectual-table/body-cells/textInput.html',
                        value: row.description,
                        model: row.description,
                        disabled: row.disabled || false,
                        options: {
                            required: true
                        }
                    };

                    row.typeEdit = {
                        url: '/templates/directives/intellectual-table/body-cells/select2.html',
                        model: row.typeEdit,
                        disabled: row.disabled || false,
                        items: [
                            'CREDIT NOTE',
                            'DEBIT NOTE'
                        ]
                    }

                    row.amountEdit = {
                        url: '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value: row.quantity,
                        id: `${row.description}-${row.consigmentId}`,
                        valueType: 'monitary',
                        disabled: row.disabled || false,
                        addOnLabel: row.currency,
                        onChange: updateCallback,
                        fullWidth: true,
                        options: {
                            required: true
                        }
                    };

                    if(row.disabled === false) {
                        row.action = {
                            type: 'button',
                            buttons: [{
                                text: 'REMOVE',
                                class: 'btn btn-danger btn-quirk btn-sm',
                                action: (row) => {
                                    tableData.data.splice(row.index, 1);
                                }
                            }]
                        };
                    }

                    if(row.disabled) {
                        row.action = {
                            type: 'button',
                            buttons: [{
                                text: 'ISSUED',
                                class: 'btn btn-green btn-quirk btn-sm',
                                action: (row) => {
                                }
                            }]
                        }
                    }
                    tableData.data.push(row);
                });
            }



            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/LineItemsTable.js